import * as React from "react";
import {stylesheet} from "typestyle";
import {useLocalization} from "../i18n";

export function LocationCode({code}: {code?: string}) {
    const {t} = useLocalization();
    if (!code) {
        return null;
    }
    return (
        <div className={styles.codeContainer}>
            <div className={styles.label}>
                {t("LocationCode")}
            </div>
            <div className={styles.code}>
                {code}
            </div>
        </div>
    );
}

const styles = stylesheet({
    codeContainer: {
        display: "flex",
        flexFlow: "row",
        alignItems: "center",
        padding: "0 0.75em"
    },
    label: {
        fontSize: "0.75em",
        whiteSpace: "pre",
        textAlign: "right",
        textTransform: "uppercase",
        marginRight: "0.5em",
        opacity: 0.75,
    },
    code: {
        fontSize: "2em",
        lineHeight: 1,
    }
});
